<template>
  <nav class="bg-white shadow sticky top-0 z-50">
  <div class="max-w-[1400px] mx-auto px-6 py-4
            flex items-center justify-between gap-10">

    <!-- LOGO -->
    <router-link
      to="/"
      class="flex items-center gap-3 shrink-0"
    >
      <img
        src="@/assets/main-logo.png"
        alt="Magnum Dental Logo"
        class="w-10 h-10 object-contain"
      />
      <span
        class="text-base sm:text-lg font-bold text-teal-700 font-serif tracking-wide
              truncate max-w-[220px] sm:max-w-none"
      >
        MAGNUM DENTAL CLINIC - GUWAHATI
      </span>
    </router-link>

<!-- RIGHT SECTION: NAV + CTA -->
<div class="hidden md:flex items-center gap-8 justify-end whitespace-nowrap">

  <!-- Nav links -->
  <!-- <div class="flex items-center gap-6 text-gray-700 font-medium">
    <router-link to="/" class="hover:text-teal-700">
      Home
    </router-link>

    <router-link to="/location" class="hover:text-teal-700">
      Location
    </router-link>
  </div> -->

  <div class="flex items-center gap-6 text-gray-700 font-medium">

  <router-link to="/" class="hover:text-teal-700">
    Home
  </router-link>

  <!-- Treatments Dropdown -->
  <div class="relative group">
    <!-- Main Treatments link -->
    <router-link
      to="/dental-services"
      class="hover:text-teal-700 flex items-center gap-1"
    >
      Treatments
      <span class="text-xs">▾</span>
    </router-link>

    <!-- Dropdown -->
    <div
      class="absolute left-0 mt-3 w-64 bg-white shadow-xl rounded-xl
             opacity-0 invisible group-hover:opacity-100 group-hover:visible
             transition-all duration-200 z-50"
    >
      <router-link
        v-for="treatment in treatments"
        :key="treatment.path"
        :to="treatment.path"
        class="block px-5 py-3 text-sm text-gray-700
       whitespace-normal break-words
       hover:bg-teal-50 hover:text-teal-700
       first:rounded-t-xl last:rounded-b-xl"
      >
        {{ treatment.name }}
      </router-link>
    </div>
  </div>

  <router-link to="/dental-clinic-in-vip-road" class="hover:text-teal-700">
  Location
</router-link>

<!-- More Dropdown -->
<div class="relative group">
  <span
    class="hover:text-teal-700 cursor-pointer flex items-center gap-1"
  >
    More
    <span class="text-xs">▾</span>
  </span>

  <div
    class="absolute right-0 mt-3 w-64 bg-white shadow-xl rounded-xl
           opacity-0 invisible group-hover:opacity-100 group-hover:visible
           transition-all duration-200 z-50"
  >
    <router-link
      v-for="link in moreLinks"
      :key="link.path"
      :to="link.path"
      class="block px-5 py-3 text-sm text-gray-700
       whitespace-normal break-words
       hover:bg-teal-50 hover:text-teal-700
       first:rounded-t-xl last:rounded-b-xl"
    >
      {{ link.name }}
    </router-link>
  </div>
</div>

</div>


  <!-- Divider -->
  <div class="h-5 w-px bg-gray-300"></div>

  <!-- Phone -->
  <a
    href="tel:+918638940021"
    class="text-sm text-gray-600 hover:text-teal-700"
  >
    📞 +91 8638940021
  </a>

  <!-- CTA -->
  <router-link
    to="/book-appointment-dental-clinic-guwahati"
    class="bg-teal-600 text-white px-5 py-2 rounded-full text-sm shadow hover:bg-teal-700 transition"
  >
    Book an Appointment
  </router-link>
</div>


    <!-- MOBILE HAMBURGER -->
    <button
      @click="isMobileMenuOpen = !isMobileMenuOpen"
      class="md:hidden text-3xl text-teal-700 focus:outline-none"
    >
      ☰
    </button>
  </div>
  <transition name="slide-right">
  <div v-if="isMobileMenuOpen" class="fixed inset-0 z-40 flex justify-end">
    <!-- Backdrop -->
    <div
      class="absolute inset-0 bg-black bg-opacity-50"
      @click="closeMobileMenu"
    ></div>

    <!-- Slide Panel -->
    <div
  class="relative w-64 bg-gradient-to-b from-teal-600 to-cyan-500 text-white
         shadow-lg p-6 z-50 h-full flex flex-col
         overflow-y-auto max-h-screen"
>
      <button
        @click="closeMobileMenu"
        class="absolute top-4 right-4 text-white text-2xl font-bold"
      >
        ✕
      </button>

      <div class="mt-16 space-y-4 text-lg font-medium">

        <!-- Home -->
        <router-link
          to="/"
          class="block bg-white/10 backdrop-blur rounded-lg px-4 py-3 shadow hover:bg-white/20 transition"
          @click="closeMobileMenu"
        >
          Home
        </router-link>

        <!-- Treatments (Dynamic Submenu) -->
        <div>
          <button
            @click="isTreatmentsOpen = !isTreatmentsOpen"
            class="w-full text-left bg-white/10 backdrop-blur rounded-lg px-4 py-3 shadow hover:bg-white/20 transition flex justify-between items-center"
          >
            Treatments
            <span class="text-sm">
              {{ isTreatmentsOpen ? "▲" : "▼" }}
            </span>
          </button>

          <div
            v-if="isTreatmentsOpen"
            class="mt-2 ml-4 space-y-2"
          >
            <router-link
              v-for="treatment in treatments"
              :key="treatment.path"
              :to="treatment.path"
              class="block bg-white/10 backdrop-blur rounded-lg px-4 py-2 text-sm shadow hover:bg-white/20 transition"
              @click="closeMobileMenu"
            >
              {{ treatment.name }}
            </router-link>
          </div>
        </div>

        <!-- Meet Our Doctors -->
        <router-link
          to="/experienced-dentists-in-guwahati"
          class="block bg-white/10 backdrop-blur rounded-lg px-4 py-3 shadow hover:bg-white/20 transition"
          @click="closeMobileMenu"
        >
          Meet Our Doctors
        </router-link>

        <!-- Why Choose Magnum Dental -->
        <router-link
          to="/trusted-dental-clinic-in-guwahati"
          class="block bg-white/10 backdrop-blur rounded-lg px-4 py-3 shadow hover:bg-white/20 transition"
          @click="closeMobileMenu"
        >
          Why Choose Us
        </router-link>


        <!-- Patient Reviews -->
        <router-link
          to="/patient-reviews-magnum-dental"
          class="block bg-white/10 backdrop-blur rounded-lg px-4 py-3 shadow hover:bg-white/20 transition"
          @click="closeMobileMenu"
        >
          Patient Reviews
        </router-link>

        <!-- Find Our Clinic -->
        <router-link
          to="/dental-clinic-in-vip-road"
          class="block bg-white/10 backdrop-blur rounded-lg px-4 py-3 shadow hover:bg-white/20 transition"
          @click="closeMobileMenu"
        >
          Find Our Clinic
        </router-link>

        <!-- FAQs -->
        <router-link
          to="/faq-dental-clinic-in-assam"
          class="block bg-white/10 backdrop-blur rounded-lg px-4 py-3 shadow hover:bg-white/20 transition"
          @click="closeMobileMenu"
        >
          Frequently Asked Questions
        </router-link>

        <!-- Book Appointment -->
        <router-link
          to="/book-appointment-dental-clinic-guwahati"
          class="block bg-white/10 backdrop-blur rounded-lg px-4 py-3 shadow hover:bg-white/20 transition"
          @click="closeMobileMenu"
        >
          Book an Appointment
        </router-link>

        <!-- Follow Us -->
<div class="mt-14 pt-8 border-t border-white/20">
  <p class="text-base font-semibold opacity-90 mb-5 text-center tracking-wide">
    Follow Us
  </p>

  <div class="flex justify-center space-x-6">

    <a
      href="https://www.instagram.com/magnumdentalclinic.md/"
      target="_blank"
      aria-label="Instagram"
      class="p-3 rounded-full bg-white/10 hover:bg-white/20
             transition-all duration-200
             hover:scale-110 active:scale-95"
    >
      <Instagram class="w-6 h-6" />
    </a>

    <a
      href="https://www.youtube.com/@MagnumDentalGuwahati"
      target="_blank"
      aria-label="YouTube"
      class="p-3 rounded-full bg-white/10 hover:bg-white/20
             transition-all duration-200
             hover:scale-110 active:scale-95"
    >
      <Youtube class="w-6 h-6" />
    </a>
  </div>
</div>

      </div>
    </div>
  </div>
</transition>

</nav>

</template>


<script>
import { Instagram, Youtube } from "lucide-vue-next";

export default {
  name: "AppNavbar",

  components: {
    Instagram,
    Youtube,
  },

  data() {
    return {
      isMobileMenuOpen: false,
      isTreatmentsOpen: false,
      treatments: [
        { name: "Teeth Cleaning / Scaling", path: "/treatments/teeth-cleaning-in-guwahati" },
        { name: "Dental Fillings", path: "/treatments/dental-filling-in-guwahati" },
        { name: "Root Canal Treatment (RCT)", path: "/treatments/root-canal-treatment-in-guwahati" },
        { name: "Braces & Aligners", path: "/treatments/dental-braces-in-guwahati" },
        { name: "Dentures", path: "/treatments/dentures-in-guwahati" },
        { name: "Dental Extractions", path: "/treatments/dental-extractions-in-guwahati" },
        { name: "Wisdom Tooth Removal (Disimpaction)", path: "/treatments/wisdom-tooth-removal-in-guwahati" },
        { name: "Dental Implants", path: "/treatments/dental-implants-in-guwahati" },
        { name: "Crowns & Bridges", path: "/treatments/tooth-replacement-in-guwahati" },
        { name: "Kids Dentistry", path: "/treatments/kids-dentistry-in-guwahati" },
        { name: "Teeth Whitening", path: "/treatments/teeth-whitening-in-guwahati" },
        { name: "Smile Designing", path: "/treatments/smile-designing-magnum-dental-clinic-guwahati" },
        { name: "Gum Treatment & Surgery", path: "/treatments/gum-treatment-in-guwahati" },
      ],
      moreLinks: [
        { name: "Meet Our Doctors", path: "/experienced-dentists-in-guwahati" },
        { name: "Why Choose Us", path: "/trusted-dental-clinic-in-guwahati" },
        { name: "Patient Reviews", path: "/patient-reviews-magnum-dental" },
        { name: "Find Our Clinic", path: "/dental-clinic-in-vip-road" },
        { name: "Frequently Asked Questions", path: "/faq-dental-clinic-in-assam" },
      ],

    };
  },

  watch: {
    isMobileMenuOpen(val) {
      document.body.style.overflow = val ? "hidden" : "";
    },
  },

  methods: {
    closeMobileMenu() {
      this.isMobileMenuOpen = false;
      this.isTreatmentsOpen = false;
      document.body.style.overflow = "";
    },
  },
};
</script>


<style scoped>
.slide-right-enter-active,
.slide-right-leave-active {
  transition: all 0.3s ease;
}
.slide-right-enter-from,
.slide-right-leave-to {
  transform: translateX(100%);
  opacity: 0;
}

.mobile-link {
  display: block;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(6px);
  border-radius: 0.75rem;
  padding: 0.75rem 1rem;
}
</style>

